<div #messagesElementRef style="padding: 10px;" [class]="getClass()">  
  <div *ngFor="let message of conversation.messages">

    <!-- A depender da origem da mensagem, a caixa onde aparece a mensagem tem um recuo para a esquerda ou para a direita. -->
    <!--  [style.margin-left]="message.origin == originBot ? 'auto': '0'" [style.margin-left]="message.origin == originUser ? '0': 'auto'"-->
    <div fxLayout="column" *ngFor="let content of message.contents" class="message-list-content {{message.origin}}">

      <div fxLayout="row" fxLayoutAlign="center center">

        <!-- Se é uma mensagem do usuário, o avatar aparece depois da mensagem. -->
        <div fxLayoutAlign="center left" *ngIf="message.origin == originUser" fxFlex="10">
          <img [src]="userAvatar() | safe:'resourceUrl'" class="serprobots-messages-list-avatars">
        </div>

        <div fxFlex="90" fxLayout="column">

          <mat-card class="message-list-content-box" [style.color]="getMessageBoxTextColor(message)"
            [style.background-color]="getMessageBoxBackgroundColor(message)">

            <!-- 
              A forma de exibição da mensagem depende do seu tipo (Text, Image, Options, etc). 
              Verificamos o tipo e passamos a responsabilidade de renderizar a mensagem para o componente responsável por isso. 
            -->
            <div [ngSwitch]="content.getType()" fxFill>

              <serprobots-message-text-content 
                 *ngSwitchCase="contentText" 
                 (requestSendOption)="onRequestSendOption($event)"
                 (requestSendText)="onRequestSendText($event)"
                 [content]="content">

              </serprobots-message-text-content>

              <serprobots-message-options-content (optionSelected)="onOptionSelect($event)"
                *ngSwitchCase="contentOptions" [content]="content"
                [disableAfterSelection]="message.shouldDisableOptionsAfterSelection()">
              </serprobots-message-options-content>

              <serprobots-message-image-content *ngSwitchCase="contentImage" [content]="content">
              </serprobots-message-image-content>

            </div>

          </mat-card>

        </div>

        <!-- Se é uma mensagem do bot, o avatar aparece antes da mensagem. -->
        <div fxLayoutAlign="center right" *ngIf="message.origin == originBot" fxFlex="10">
          <img [src]="botAvatar() | safe:'resourceUrl'" class="serprobots-messages-list-avatars">
        </div>

      </div>

    </div>

    <!-- Verificar se deve exibir a data que a mensagem foi criada. -->
    <div fxLayoutAlign="center center" class="message-list-date" [class]="getClass()"
      *ngIf="configuration.showMessageDate" [style.font-size]="configuration.dateTextSize">{{ message.date | date:
      configuration.messageDateFormat }}</div>


  </div>

  <div *ngIf="isSending && configuration.showIsTyping" [class]="'message-list-content-box-typing ' + getClass()"
    fxLayoutAlign="center center">{{ getTypingText() }}</div>
  <div fxLayoutAlign="center center"><img *ngIf="isSending && configuration.typingImage"
      [src]="configuration.typingImage | safe:'resourceUrl'"></div>
</div>